import React from 'react'

import useStyles from './styles'

const UserOverride = ({ override }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>{override ? 'Active' : 'Not Active'}</div>
  )
}

export default UserOverride
